import { IZoneData, Zones as ZonesLib } from "@package/map";
import Api from "Api";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { setTooltip } from "Redux/tooltipSlice";
import { changeApplySelected, changeAutoApply } from "Redux/zonesSlice";
import { changeLoadingMode } from "Redux/surveysSlice";
import { useEffect, useMemo, useState } from "react";
import { Marker, Pane, Rectangle, Tooltip } from "react-leaflet";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import useTravelCount from "Hooks/useTravelCount";

export default function TravelHeatMap2() {
  const dispatch = useAppDispatch();

  const {
    source,
    destination,
    level,
    visible: zonesVisible,
    zone,
    zonesCount,
    showTopNumbers,
    heatMap2Mode,
    selectingType,
    autoApply,
    applySelecteds,
    forceUpdate,
    colorStep,
    showHeatMap2Numbers,
  } = useAppSelector((state) => state.trafficZones);
  const { visible: travelVisible, travelShowType, type } = useAppSelector((state) => state.travel);
  const { zoom } = useAppSelector((state) => state.map);
  const { survayLayer } = useAppSelector((state) => state.layers);
  const StorageZonesData = useMemo(() => localStorage.getItem(`zone-data-${zone}-${level}`), [zone, level]);
  const [zonesData, setZonesData] = useState(StorageZonesData ? JSON.parse(StorageZonesData) : []);
  const [selectedZonesCount, setSelectedZonesCount] = useState<any>({ des: {}, src: {} });
  const [surveyCounts, setSurveyCounts] = useState<any>({ des: {}, src: {}, storedDes: {}, storedSrc: {} });
  const [allSurveyCounts, setAllSurveyCounts] = useState<any>({ des: {}, src: {} });

  const { data } = useTravelCount();

  // useEffect(() => {
  //   if (!zonesVisible) {
  //     dispatch(changeAutoApply(false));
  //     dispatch(changeApplySelected(false));
  //   }
  // }, [zonesVisible]);

  // const { data, isLoading, refetch, isFetching } = useQuery({
  //   queryKey: [applySelecteds, source, destination, autoApply, travelShowType, type],
  //   queryFn: () => {
  //     if (autoApply || travelShowType === 2) {
  //       if (source.length === 0 && destination.length > 0) {
  //         const temp: any = {};
  //         for (let i = 0; i < destination.length; i += 1) {
  //           const c = allSurveyCounts.des[destination[i]];
  //           if (c) {
  //             temp[String(destination[i])] = c;
  //           } else {
  //             temp[String(destination[i])] = 0;
  //           }
  //         }
  //         return Api.sPost(
  //           `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //           testData
  //         ).then((res) => {
  //           setSurveyCounts({ des: temp, src: res?.data?.Data?.sourceCount });
  //         });
  //       }
  //       if (destination.length === 0 && source.length > 0) {
  //         const temp: any = {};
  //         for (let i = 0; i < source.length; i += 1) {
  //           const c = allSurveyCounts.src[source[i]];
  //           if (c) {
  //             temp[String(source[i])] = c;
  //           } else {
  //             temp[String(source[i])] = 0;
  //           }
  //         }
  //         return Api.sPost(
  //           `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //           testData
  //         ).then((res) => {
  //           setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: temp });
  //         });
  //       }
  //       return Api.sPost(
  //         `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //         testData
  //       ).then((res) => {
  //         setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
  //       });
  //     }
  //     if (!autoApply && applySelecteds) {
  //       if (source.length === 0 && destination.length > 0) {
  //         const temp: any = {};
  //         for (let i = 0; i < destination.length; i += 1) {
  //           const c = allSurveyCounts.des[destination[i]];
  //           if (c) {
  //             temp[String(destination[i])] = c;
  //           } else {
  //             temp[String(destination[i])] = 0;
  //           }
  //         }
  //         return Api.sPost(
  //           `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //           testData
  //         ).then((res) => {
  //           setSurveyCounts({ des: temp, src: res?.data?.Data?.sourceCount });
  //         });
  //       }
  //       if (destination.length === 0 && source.length > 0) {
  //         const temp: any = {};
  //         for (let i = 0; i < source.length; i += 1) {
  //           const c = allSurveyCounts.src[source[i]];
  //           if (c) {
  //             temp[String(source[i])] = c;
  //           } else {
  //             temp[String(source[i])] = 0;
  //           }
  //         }
  //         return Api.sPost(
  //           `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //           testData
  //         ).then((res) => {
  //           setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: temp });
  //         });
  //       }
  //       return Api.sPost(
  //         `report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute`,
  //         testData
  //       ).then((res) => {
  //         setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
  //       });
  //     }
  //   },
  //   enabled: true,
  // });

  // useEffect(() => {
  //   dispatch(changeLoadingMode(isLoading));
  // }, [isLoading]);

  // console.log(allSurveyCounts, "bvuygujgb");

  if (!travelVisible || !data) return <></>;
  return (
    <>
      <Pane name="show_travel_heatmap2" style={{ zIndex: survayLayer }} key={survayLayer}>
        <ZonesLib
          zone={zone}
          level={level}
          zoom={zoom}
          zonesVisible={zonesVisible}
          heatMap={true}
          haetmapZIndex={survayLayer}
          heatMapMode={heatMap2Mode}
          autoApply={autoApply}
          applySelecteds={applySelecteds}
          zonesCount={showTopNumbers ? zonesCount : 329}
          showTopNumbers={showTopNumbers}
          forceUpdate={forceUpdate}
          colorStep={colorStep}
          surveyCounts={surveyCounts}
          allSurveyCounts={{ des: JSON.parse(`{${data?.destinationCount}}`), src: JSON.parse(`{${data?.sourceCount}}`) }}
          isLoading={false}
          selectedZonesCount={selectedZonesCount}
          showHeatMap2Numbers={showHeatMap2Numbers}
          selectionMode={applySelecteds && travelVisible && travelShowType === 2}
          zonesColor={[
            { zones: source, color: "#00a185" },
            { zones: destination, color: "#07243e" },
          ]}
        />
      </Pane>
    </>
  );
}
